module.exports = __webpack_public_path__ + "img/s_atanasov.4b0bac58.jpg";